// extracted by mini-css-extract-plugin
module.exports = {"container":"e_bi","icon":"e_ci","pathBg":"e_di","pathFg":"e_ei","variantViolet":"e_fi","variantBase":"e_gi"};